/* Dr.Primal — the quantity stepper.

   `snippets/dp-qty.liquid` renders a real <input type="number"> between two buttons, so
   it posts inside a form with no JavaScript at all. This file makes the −/+ buttons do
   something everywhere the stepper is used.

   The cart drawer is deliberately excluded: `dp-cart-drawer.js` steps its own controls
   because each change is a debounced Cart API call with a rollback, and two handlers on
   one control is the class of defect this theme keeps its distance from. */
(function () {
  'use strict';

  function clamp(value, min, max) {
    if (!isNaN(min)) value = Math.max(min, value);
    if (!isNaN(max)) value = Math.min(max, value);
    return value;
  }

  function syncEnds(wrapper, value, min, max) {
    Array.prototype.forEach.call(wrapper.querySelectorAll('[data-dp-qty-step]'), function (step) {
      var delta = parseInt(step.getAttribute('data-dp-qty-step'), 10);
      step.disabled = (delta < 0 && value <= min) || (delta > 0 && value >= max);
    });
  }

  function onStep(button) {
    var wrapper = button.closest('[data-dp-qty]');
    if (!wrapper) return;
    if (wrapper.closest('[data-dp-cart-drawer]')) return;

    var input = wrapper.querySelector('[data-dp-qty-input]');
    if (!input) return;

    var min = parseInt(wrapper.getAttribute('data-dp-qty-min'), 10);
    var max = parseInt(wrapper.getAttribute('data-dp-qty-max'), 10);
    var delta = parseInt(button.getAttribute('data-dp-qty-step'), 10);
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = isNaN(min) ? 1 : min;

    var next = clamp(current + delta, min, max);
    if (String(next) === input.value) return;

    input.value = next;
    syncEnds(wrapper, next, min, max);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function onType(input) {
    var wrapper = input.closest('[data-dp-qty]');
    if (!wrapper) return;
    if (wrapper.closest('[data-dp-cart-drawer]')) return;

    var min = parseInt(wrapper.getAttribute('data-dp-qty-min'), 10);
    var max = parseInt(wrapper.getAttribute('data-dp-qty-max'), 10);
    var value = parseInt(input.value, 10);
    if (isNaN(value)) return;

    var clamped = clamp(value, min, max);
    if (clamped !== value) input.value = clamped;
    syncEnds(wrapper, clamped, min, max);
  }

  function init() {
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var step = event.target.closest('[data-dp-qty-step]');
      if (step) onStep(step);
    });

    document.addEventListener('change', function (event) {
      if (!(event.target instanceof Element)) return;
      if (event.target.matches('[data-dp-qty-input]')) onType(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
